module.exports = __webpack_public_path__ + "static/media/prev-course-history-disabled.6e8fd846.svg";